import styled from 'styled-components';
import EmptyPlaceholder from '@components/common/EmptyPlaceholder';

export const RetryLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
  background-color: rgb(255 255 255 / 90%);
`;

export const ErrorHolder = styled.div`
  position: relative;
  top: 10%;
  right: 0;
  left: 0;
  margin: inherit;
  margin-top: 0.1rem;
  text-align: center;
  font-size: 0.75rem;
  color: #262626;
  z-index: 11;
`;

export const ErrorMessage = styled.div<{
  horizontal: boolean;
}>`
  background-color: transparent;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: bold;
  display: flex;
  flex-direction: ${(props) => (props.horizontal ? 'row' : 'column')};
  place-content: space-around center;
`;

export const HorizontalMessage = styled.div`
  display: inline-flex;
  position: relative;
  background-color: transparent;
  width: 490px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 100;
  text-align: center;
`;

export const CardWrapper = styled.div<{
  horizontal: boolean;
}>`
  display: flex;
  flex-direction: ${(props) => (props.horizontal ? 'row' : 'column')};
  place-content: space-around space-around;
  align-items: center;
  ${(props) =>
    props.horizontal
      ? `
      .message {
        display: none;
      }
      > div {
        margin: 5px;
      }
    `
      : `
      .message {
        position: relative;
        font-size: .85rem;
        font-weight: 100;
        text-align: center;
        width: 250px;
        margin: 5px;
      }
    `}
`;

export const InfoMessage = styled.div`
  position: relative;
  font-size: 0.85rem;
  font-weight: 100;
  text-align: center;
  width: 250px;
`;

export const Wrapper = styled.div<{
  compact?: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: ${(props) => (props.compact ? '50px' : '115px')};
`;

export const Layer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
  background-color: rgb(255 255 255 / 50%);
  overflow: hidden;
  border: 1px solid rgb(255 255 255 / 50%);
  width: 100%;
  height: 100%;
  backdrop-filter: blur(2px);
`;

export const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  max-width: 300px;
  z-index: 11;
  padding: 10px;
  text-align: center;
  background: rgb(255 255 255 / 50%);
  box-shadow: 0 0 10px 10px rgb(255 255 255 / 50%);
  border-radius: 50%;
`;

export const NoData = styled(EmptyPlaceholder)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
